{
    "PageTitle_admin": "Administration",
    "PageTitle_auth": "Authentication",
    "PageTitle_presence": "Presence",
    "PageTitle_changePassword": "Change Password",
    "PageTitle_forgotPassword": "Forgot Password",
    "PageTitle_changeLanguage": "Change Language",
    "PageTitle_resetPassword": "Reset Password",
    "PageTitle_termsAndConditions": "Terms and Conditions",
    "PageTitle_cookiePolicy": "Cookie Policy",
    "PageTitle_privacyPolicy": "Privacy Policy",
    "PageTitle_mfa": "Multi-Factor Authentication",
    "PageTitle_teamsAuth": "Teams Authentication",
    "PageTitle_insights": "Insights",
    "PageTitle_clientConfiguration": "Client Configuration",
    "PageTitle_cme": "CMEs",
    "PageTitle_status": "Application Server Status",
    "PageTitle_licences": "Licences",
    "PageTitle_licenceManagement": "Licence Management",
    "PageTitle_telsys": "Telephony Servers",
    "PageTitle_users": "Application Users",
    "PageTitle_partitions": "Partitions",
    "PageTitle_device": "Devices",
    "PageTitle_agent": "Agents",
    "PageTitle_code": "Codes",
    "PageTitle_auditTrail": "Audit Trail",
    "PageTitle_logManagement": "Log Management",
    "PageTitle_loggingSettings": "Logging Settings",
    "PageTitle_telModuleStatus": "Telephone Module Status",
    "PageTitle_recording": "Recording",
    "PageTitle_messages": "Messages",
    "PageTitle_database": "Database",
    "PageTitle_directory": "Directory",
    "PageTitle_crmIntegration": "CRM Integration",
    "PageTitle_changeUserAgent": "Change User Agent",
    "PageTitle_cxScore": "CX Score",
    "PageTitle_cxScore-cx-score": "CX Score",
    "PageTitle_cxScore-overview": "CX Score",
    "PageTitle_cxScore-calls": "CX Score",
    "PageTitle_cxiDashboard": "CXI Dashboard",
    "NAME": "Router"
}
